/**
 * @license Copyright 2019 Google Inc. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License"); you may not use this file except in compliance with the License. You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0
 * Unless required by applicable law or agreed to in writing, software distributed under the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions and limitations under the License.
 */

.pwa-icon {
  width: 18px;
  height: 18px;
}

.pwa-icon__background {
  fill: var(--neutral-color);
}

.pwa-icon--improvement .pwa-icon__background {
  fill: var(--improvement-color);
}

.pwa-icon--regression .pwa-icon__background {
  fill: var(--regression-color);
}

.pwa-gauge {
  width: var(--gauge-size);
  height: var(--gauge-size);
}

/* Turn off all components by default and only enable what is active */
.pwa-gauge .pwa-gauge__component {
  display: none;
}

.pwa-gauge:not(.pwa-gauge--all) .pwa-gauge__logo > path {
  /* Gray logo unless everything is passing. */
  fill: #b0b0b0;
}

.pwa-gauge__disc {
  fill: var(--secondary-background-color);
}

.pwa-gauge__logo--primary-color {
  fill: #304ffe;
}

.pwa-gauge__logo--secondary-color {
  fill: #3d3d3d;
}

/* No passing groups. */
.pwa-gauge:not([class*='pwa-gauge--']) .pwa-gauge__na-line {
  display: inline;
}

/* Just optimized. Same n/a line as no passing groups. */
.pwa-gauge.pwa-gauge--pwa-optimized:not(.pwa-gauge--pwa-installable):not(.pwa-gauge--pwa-fast-reliable)
  .pwa-gauge__na-line {
  display: inline;
}

/* Just fast and reliable. */
.pwa-gauge.pwa-gauge--pwa-fast-reliable:not(.pwa-gauge--pwa-installable)
  .pwa-gauge__fast-reliable-badge {
  display: inline;
}

/* Just installable. */
.pwa-gauge.pwa-gauge--pwa-installable:not(.pwa-gauge--pwa-fast-reliable)
  .pwa-gauge__installable-badge {
  display: inline;
}

/* Fast and reliable and installable. */
.pwa-gauge.pwa-gauge--pwa-fast-reliable.pwa-gauge--pwa-installable
  .pwa-gauge__fast-reliable-installable-badges {
  display: inline;
}

/* All passing groups. */
.pwa-gauge.pwa-gauge--all .pwa-gauge__check-circle {
  display: inline;
}
